import {disableBodyScroll, enableBodyScroll} from 'body-scroll-lock';
import naja from "naja";
import Form from "./Form";
import Counter from "./Counter";

export default class Filter {

    static init() {
        this.initFilterForm();
        this.handleFiltersUpdate();
        this.handleToggleLoadMore();

        const toggle = document.getElementById('filterToggle');
        const container = document.getElementById('filterContainer');
        const category = document.getElementById('categoryFilter');
        const closer = document.getElementById('filterCloser');

        if (toggle && container && category) {
            toggle.addEventListener('click', e => {
                e.preventDefault();
                if (window.matchMedia('(max-width: 1279px)').matches) {
                    disableBodyScroll(category);
                }
                toggle.classList.toggle('open');
                container.classList.toggle('category-filter-container--open');
            });
            closer.addEventListener('click', e => {
                e.preventDefault();
                if (window.matchMedia('(max-width: 1279px)').matches) {
                    enableBodyScroll(category);
                }
                container.classList.remove('category-filter-container--open');
            });
            Filter.handleMobile();
        }

    }

    static getSiblings(elem) {

        // Setup siblings array and get the first sibling
        var siblings = [];
        var sibling = elem.parentNode.firstChild;

        // Loop through each sibling and push to the array
        while (sibling) {
            if (sibling.nodeType === 1 && sibling !== elem) {
                siblings.push(sibling);
            }
            sibling = sibling.nextSibling;
        }
        return siblings;
    };

    static handleMobile() {
        const items = document.querySelectorAll('.jsCategoryFilterItem');

        if (items.length > 0) {
            items.forEach(item => {
                let header = item.querySelector('.category-filter__header');
                if (header) {
                    header.addEventListener('click', () => {
                        item.classList.toggle('category-filter__item--open');
                        let siblings = Filter.getSiblings(item);
                        siblings.forEach(sibling => {
                            sibling.classList.toggle('category-filter__item--inactive');
                        });
                    });
                }
            })
        }
    }

    static initFilterForm() {
        const formInputs = document.querySelectorAll('#frm-productFilter-filterForm input');

        if (formInputs.length > 0) {
            formInputs.forEach(input => {
                let clone = input.cloneNode(true);
                input.parentNode.replaceChild(clone, input);
                clone.addEventListener('change', () => {
                    naja.uiHandler.submitForm(document.querySelector('#frm-productFilter-filterForm'));
                })
            })
        }
    }

    static handleFiltersUpdate() {
        const productsContainer = document.getElementById('snippet--products');

        naja.snippetHandler.addEventListener('afterUpdate', (event) => {
            if (event.detail.snippet.id === 'snippet--products') {
                Counter.init();
            }
        });

        naja.snippetHandler.addEventListener('afterUpdate', (event) => {
            if (event.detail.snippet.id === 'snippet--categoryList-priceFilter') {
                Form.sliderDesktop();
            }
        });

        naja.snippetHandler.addEventListener('afterUpdate', (event) => {
            if (event.detail.snippet.id === 'snippet-priceFilterMobile-prices') {
                Form.sliderMobile();
            }
        });

        naja.snippetHandler.addEventListener('afterUpdate', (event) => {
            if (event.detail.snippet.id.includes('snippet-productFilter')) {
                this.initFilterForm();
                Form.handleSortSelect();
            }
        });

        naja.snippetHandler.addEventListener('afterUpdate', (event) => {
            if (event.detail.snippet.id === 'snippet--categoryList-sort') {
                Form.handleSortSelect();
            }
        });

        naja.snippetHandler.addEventListener('afterUpdate', (event) => {
            if (event.detail.snippet.id === 'snippet--categoryList-sort') {
                Form.handleSortSelect();
            }
        });

        const form = document.getElementById('frm-productFilter-filterForm');
        const formPrice = document.getElementById('frm-priceFilter-priceForm');
        const formPriceMobile = document.getElementById('frm-priceFilterMobile-priceForm');

        if(form) {
            naja.addEventListener('complete', (event) => {
                form.action = event.detail.payload.url;
            });
        }
        if(formPrice) {
            naja.addEventListener('complete', (event) => {
                formPrice.action = event.detail.payload.url;
            });
        }
        if(formPriceMobile) {
            naja.addEventListener('complete', (event) => {
                formPriceMobile.action = event.detail.payload.url;
            });
        }

        if(productsContainer) {
            naja.snippetHandler.addEventListener('afterUpdate', (event) => {
                if (event.detail.snippet.id === 'snippet--btnNext') {
                    productsContainer.removeAttribute('data-naja-snippet-append');
                    this.handleToggleLoadMore();
                }
            });
        }
    }

    static handleToggleLoadMore() {
        let toggle = document.getElementById('load-more-button');
        let productsContainer = document.getElementById('snippet--products');

        if(toggle && productsContainer) {
            toggle.addEventListener('click', function (e) {
                e.preventDefault();
                productsContainer.setAttribute('data-naja-snippet-append', true);
            })
        }

    }
}
